import { Link } from "react-router-dom";
import { ContributorProfile, Profile } from "@app/types/Cue";
import { cn } from "@util/helpers";

type BylineNameProps = {
  profile: Profile | ContributorProfile;
  separator: "," | "&" | "";
  rootClassName?: string;
  linkClassName?: string;
};

export default function BylineName({
  profile,
  separator,
  rootClassName,
  linkClassName,
}: BylineNameProps): React.ReactElement {
  const authorName = profile.content.fields.name;
  const urlPath = profile.content.urlPath;

  return (
    <>
      {urlPath ? (
        <h4 className={cn(rootClassName)}>
          <Link
            to={urlPath}
            className={cn(
              "word-break text-base !text-gray-850 hover:underline",
              linkClassName
            )}
            target="_blank"
            reloadDocument
          >
            {authorName} {separator}
          </Link>
        </h4>
      ) : null}
    </>
  );
}
